// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="\$ctrl.headerTitle"></sub-header>

    <div class="alert-container">
      <div class="alert alert--danger" ng-repeat="error in \$ctrl.errorMessages">
        <span><strong>Error:</strong> {{error}}</span>
      </div>
    </div>
    <h2 class="section-header">{{\$ctrl.formTitle}}</h2>
    <div ng-transclude></div>
</section>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/page/miscellaneous-transactions-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;